module.exports = __webpack_public_path__ + "img/logo.2bbfc9a7.png";